// kontaktStand.ts — „das war ich selbst": eigene Speichervorgänge am Kontakt
// außerhalb des Anlage-Formulars (28.09.2026).
//
// Die Akte speichert beim Sperren ZUERST die Kopf-Felder (Jahresgespräch,
// persönlicher Kontakt …) über `PUT contact/:id`, DANN das Formular. Der
// Kopf-PUT zählt den Bearbeitungsstand hoch — ohne Meldung hielte das
// Formular seinen eigenen Kopf für „jemand anderes" und bekäme 409.
//
// Wer `PUT/PATCH contact/:id` selbst schickt, meldet hier den Stand aus der
// Antwort. Das Formular übernimmt ihn nur, wenn er GENAU eins über seinem
// liegt — hat dazwischen doch jemand anderes gespeichert, bleibt der alte
// Stand stehen und der Konflikt wird gemeldet.

type Hoerer = (neuerStand: number) => void;

const hoerer = new Map<number, Set<Hoerer>>();

/** Nach eigenem `PUT/PATCH contact/:id`: den Stand aus der Antwort melden. */
export function eigenenStandMelden(contactId: number, neuerStand: unknown): void {
  if (typeof neuerStand !== "number" || !Number.isInteger(neuerStand)) return;
  for (const h of hoerer.get(contactId) ?? []) h(neuerStand);
}

/** Abonnieren; liefert die Abmeldung. */
export function aufEigenenStandHoeren(contactId: number, h: Hoerer): () => void {
  let set = hoerer.get(contactId);
  if (!set) hoerer.set(contactId, (set = new Set()));
  set.add(h);
  return () => {
    set!.delete(h);
    if (set!.size === 0) hoerer.delete(contactId);
  };
}

/** Übernimmt `neu` nur als direkten Nachfolger des bekannten Stands. */
export function standNachEigenemSchreiben(bekannt: number | null, neu: number): number | null {
  return bekannt != null && neu === bekannt + 1 ? neu : bekannt;
}
